import { SimpleGrid, Box } from '@chakra-ui/layout'
import loadable from '@loadable/component'
import map from 'lodash/map'
import React from 'react'
import LinkStats from '../../adminComponents/ProfileEditor/LinkStats'
import ImageBox from './ImageBox'

const Carousel = loadable(() => import('../../components/Carousel'))

const ImageBoxes = ({
  items,
  variant,
  links,
  ratio = 1,
  perRow = 1,
  isPreview,
  isEditing,
  autoplay,
  autoplaySpeed,
  id: blockId,
  profileId,
  impressions,
  clicks,
}) => {
  const children = map(items, ({
    image,
    alt,
    id,
    itemId,
    linkId,
    styles,
    tag,
    textGradient,
    textSolid,
    frame,
    ...item
  }, i) => {
    const data = {
      ...((isPreview && item['linkId-editor']) || links?.[linkId]),
      text: item.text,
    }
    const child = (
      <ImageBox
        key={i}
        src={image}
        alt={alt}
        tag={tag}
        data={data}
        frame={frame}
        ratio={ratio}
        variant={variant}
        id={itemId ?? id}
        linkId={linkId}
        blockId={blockId}
        profileId={profileId}
        isSmall={perRow > 1}
        isEditing={isEditing}
        isPreview={isPreview}
        // {...styles}
      />
    )
    return isEditing ? (
      <LinkStats
        key={linkId ?? i}
        linkId={linkId}
        compact={perRow > 1}
        blockId={blockId}
        profileId={profileId}
        itemId={itemId ?? id}
        impressions={impressions}
        clicks={clicks}
      >{child}</LinkStats>
    ) : child
  })
  return (
    <Box width="full" as="section">
      {perRow > 1 || children.length === 1 ? (
        <SimpleGrid columns={perRow} spacing="1em">
          {children}
        </SimpleGrid>
      ) : (
        <Carousel
          ratio={ratio}
          key={String(autoplay)}
          autoplay={autoplay}
          autoplaySpeed={(autoplaySpeed || 5) * 1000}
        >{children}</Carousel>
      )}
    </Box>
  )
}

export default ImageBoxes
